import React, { useState } from 'react';

const Tooltip = ({ children, tooltipText }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && tooltipText && (
        <div 
          style={{
            position: 'absolute',
            bottom: '-20px', 
            left: '-110px',
            transform: 'translateX(-50%)',
            backgroundColor: 'black',
            color: '#9c9c9c',
            padding: '5px',
            borderRadius: '10px',                  
            fontSize: '15px',
            whiteSpace: 'break-spaces',
            width: '200px'
          }}
        >
          {tooltipText}
        </div>
      )}
    </div>
  );
};

export default Tooltip;